import Handler from 'universal-cookie';
import { config } from '/app/config';

const { isProd } = config.app;

const cookie = new Handler();

export default class Cookie
{
    /**
     * Get the cookie.
     *
     * @param  {string}  key
     * @param  {mixed}  value
     * @return {string}
     */
    static get(key, value = null)
    {
        return cookie.get(key) || value;
    }

    /**
     * Set the cookie.
     *
     * @param  {string}  key
     * @param  {string}  value
     * @param  {number}  days
     * @return {string}
     */
    static set(key, value, shared = false, days)
    {
        const domain = (new URL(config.app.baseURL)).hostname;
        const age = days === Infinity ? 100 * 365 * 24 * 60 * 60 : (days ? days * 24 * 60 * 60 : null);

        cookie.set(key, value, {
            path: '/',
            maxAge: age,
            secure: isProd,
            sameSite: 'strict',
            domain: shared ? domain : null,
        });

        return Cookie;
    }

    /**
     * Delete the cookie.
     *
     * @param  {string}  key
     * @return {void}
     */
    static delete(key, shared = false)
    {
        const domain = (new URL(config.app.baseURL)).hostname;
        cookie.remove(key, {
            path: '/',
            secure: isProd,
            sameSite: 'strict',
            domain: shared ? domain : null,
        });

        return Cookie;
    }

    /**
     * Determine if the cookie exists.
     *
     * @param  {string}  key
     * @param  {string}  value
     * @return {bool}
     */
    static has(key, value = null)
    {
        return ! value ? !! this.get(key) : this.get(key) == value;
    }
}
